import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {WalletCard, WalletCardStyle} from "./WalletCard";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {AddFundsMinimised} from "../pages/add-funds/sections/AddFundsMinimised";
import {WidgetMerchantTheme} from "../WidgetTheme";


export class MerchantCardStyle extends WalletCardStyle {
    @styleRuleInherit
    container = {
        zIndex: 2,
        color: "initial",
    };

    @styleRuleInherit
    title = {
        color: "#000000",
    };
}

@registerStyle(MerchantCardStyle)
export class MerchantCard extends WalletCard {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            theme: WidgetMerchantTheme,
        }
    }

    computeHeight() {
        return super.computeHeight() + AddFundsMinimised.getHeight();
    }
}
